/* eslint-disable @typescript-eslint/no-explicit-any */
import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import api from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import * as commonSagas from '../_common/commonSagas';
import { RolesDTO } from './accessGroupsTypes';
import * as accessGroupsSlice from './accessGroupsSlice';

function* accessGroupsGetRolesSaga(
 props: PayloadAction<{ accessGroupId: string }>,
) {
 try {
  const response: AxiosResponse<RolesDTO[]> = yield call(
   api.get,
   `/AccessGroups/v1/${props.payload.accessGroupId}/roles`,
  );
  yield put(accessGroupsSlice.accessGroupsGetRolesSuccess(response.data));
 } catch (error) {
  yield* errorHandling(error, accessGroupsSlice.accessGroupsGetRolesFailure);
 }
}

function* accessGroupsGetRolesTableSaga(props: PayloadAction<any>) {
 try {
  const response: AxiosResponse<RolesDTO[]> = yield call(
   api.post,
   '/AccessGroups/v1/roles',
   props.payload,
  );
  yield put(accessGroupsSlice.accessGroupsGetRolesTableSuccess(response.data));
 } catch (error) {
  yield* errorHandling(
   error,
   accessGroupsSlice.accessGroupsGetRolesTableFailure,
  );
 }
}

function* accessGroupsAddRoleSaga(
 props: PayloadAction<{ accessGroupId: string; roles: RolesDTO[] }>,
) {
 try {
  yield call(
   api.post,
   `/AccessGroups/v1/${props.payload.accessGroupId}/roles/add`,
   props.payload.roles,
  );
  yield put(
   accessGroupsSlice.accessGroupsAddRoleSuccess({
    message: 'Roles added successfully',
    type: 'success',
   }),
  );
 } catch (error) {
  yield* errorHandling(error, accessGroupsSlice.accessGroupsAddRoleFailure);
 }
}

function* accessGroupsCreateRoleSaga(props: PayloadAction<RolesDTO>) {
 try {
  const response: AxiosResponse<RolesDTO> = yield call(
   api.post,
   '/AccessGroups/v1/roles/create',
   props.payload,
  );
  yield put(
   accessGroupsSlice.accessGroupsCreateRoleSuccess({
    type: 'success',
    message: 'Role created successfully',
    data: response.data,
   }),
  );
 } catch (error) {
  yield* errorHandling(error, accessGroupsSlice.accessGroupsCreateRoleFailure);
 }
}

function* accessGroupsUpdateRoleSaga(
 props: PayloadAction<{ id: string; data: RolesDTO }>,
) {
 try {
  const response: AxiosResponse<RolesDTO> = yield call(
   api.put,
   `/AccessGroups/v1/roles/update/${props.payload.id}`,
   props.payload.data,
  );
  yield put(accessGroupsSlice.accessGroupsUpdateRoleSuccess(response.data));
 } catch (error) {
  yield* errorHandling(error, accessGroupsSlice.accessGroupsUpdateRoleFailure);
 }
}

function* accessGroupsDeleteRoleSaga(props: PayloadAction<RolesDTO>) {
 try {
  const roleId = props.payload.Id;
  if (roleId) {
   yield call(
    api.del,
    `/AccessGroups/v1/roles/delete/${roleId}`,
    props.payload,
   );
  }
  yield put(accessGroupsSlice.accessGroupsDeleteRoleSuccess());
 } catch (error) {
  yield* errorHandling(error, accessGroupsSlice.accessGroupsDeleteRoleFailure);
 }
}

function* accessGroupsRemoveRoleSaga(
 props: PayloadAction<{ accessGroupId: string; roles: RolesDTO[] }>,
) {
 try {
  yield call(
   api.del,
   `/AccessGroups/v1/${props.payload.accessGroupId}/roles/remove`,
   props.payload.roles,
  );
  yield put(
   accessGroupsSlice.accessGroupsRemoveRoleSuccess({
    message: 'Roles removed successfully',
    type: 'success',
   }),
  );
 } catch (error) {
  yield* errorHandling(error, accessGroupsSlice.accessGroupsRemoveRoleFailure);
 }
}

function* accessGroupsDeleteGroupSaga(props: PayloadAction<{ id: string }>) {
 try {
  yield call(api.del, `/AccessGroups/v1/delete/${props.payload.id}`, {});
  yield put(accessGroupsSlice.accessGroupsDeleteGroupSuccess());
 } catch (error) {
  yield* errorHandling(error, accessGroupsSlice.accessGroupsDeleteGroupFailure);
 }
}

export function* watchAccessGroupsSaga() {
 yield takeLatest(accessGroupsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(accessGroupsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(
  accessGroupsSlice.createItemStart.type,
  commonSagas.createItem,
 );
 yield takeLatest(
  accessGroupsSlice.updateItemStart.type,
  commonSagas.updateItem,
 );
 yield takeLatest(
  accessGroupsSlice.accessGroupsGetRolesStart.type,
  accessGroupsGetRolesSaga,
 );
 yield takeLatest(
  accessGroupsSlice.accessGroupsGetRolesTableStart.type,
  accessGroupsGetRolesTableSaga,
 );
 yield takeLatest(
  accessGroupsSlice.accessGroupsAddRoleStart.type,
  accessGroupsAddRoleSaga,
 );
 yield takeLatest(
  accessGroupsSlice.accessGroupsCreateRoleStart.type,
  accessGroupsCreateRoleSaga,
 );
 yield takeLatest(
  accessGroupsSlice.accessGroupsUpdateRoleStart.type,
  accessGroupsUpdateRoleSaga,
 );
 yield takeLatest(
  accessGroupsSlice.accessGroupsDeleteRoleStart.type,
  accessGroupsDeleteRoleSaga,
 );
 yield takeLatest(
  accessGroupsSlice.accessGroupsRemoveRoleStart.type,
  accessGroupsRemoveRoleSaga,
 );
 yield takeLatest(
  accessGroupsSlice.accessGroupsDeleteGroupStart.type,
  accessGroupsDeleteGroupSaga,
 );
}

